// extracted by mini-css-extract-plugin
module.exports = {"normal":"LabelWeight_normal__otACn","medium":"LabelWeight_medium__XLEas","strong":"LabelWeight_strong__KGe2h"};